import InsuranceMixins from "@/desktop/views/mv/PolicyInfo/components/Insurance";
export default {
  mixins: [InsuranceMixins],
  components: {},
  data: () => ({
    originalFamilyList: [],
    familyIndex: 0,
    familyDatas: JSON.parse(localStorage.familyDatas) || [], //家戶成員列表(多筆)
    familyOwner: [], //主被保人
    familyMembers: [], //主被保人家戶成員
    insurances: JSON.parse(localStorage.insurances) || [], //自行輸入國泰壽險列表
    isSave: false,
    inserData: {
      insertList: [],
      delList: []
    },
    familyOwnerList: []
  }),
  methods: {
    familyLeader() {
      return this.options.families.filter((x) => x.familyrl === 0)[0] || {};
    },
    assignFamilyMembers(i, obj) {
      Object.assign(this.familyMembers[i], obj);
    },
    //新增
    addFamilyMembers(csid) {
      this.familyMembers.push({
        csid: csid,
        cop_id: "", //ID
        cop_name: "", //姓名
        cop_birthday: "", //生日
        cop_kind: "", //身份
        nmShow: false,
        birShow: false
      });
    },
    async checkValidate() {
      return new Promise(async (resolve) => {
        if (await this.$validator.validateAll()) {
          resolve();
        } else {
          const errorRuls = this.errors.items.map((x) => x.rule);
          if (errorRuls.filter((x) => x === "required").length) {
            this.$toast.info({ title: "尚有欄位未填，請確認" });
          }
        }
      });
    },
    //檢核
    addValidation(family) {
      if (!family.cop_kind) {
        this.setToastMsg("請選擇與主被保人關係");
        return false;
      }
      return true;
    },
    //檢核是否有生日
    checkBirthday(familyMembers) {
      let rAry = familyMembers
        .filter((x) => !x.cop_birthday)
        .map((item) => item.cop_id);
      if (rAry && rAry.length > 0) {
        this.setToastMsg("請先刪除無生日的眷屬，編輯生日後再加入該成員");
        return false;
      }
      return true;
    },
    //無生日顯示紅框提示
    isBirShow(birthday) {
      if (!birthday) {
        return true;
      }
      return false;
    },
    isCopKindC(familyMembers) {
      let rAry = familyMembers
        .filter((x) => x.cop_kind === "C")
        .map((item) => item.cop_name);
      if (rAry && rAry.length > 1) {
        this.$toast.info({
          title: `僅能有一位「配偶」，請再次確認家戶成員的身份。`
        });
        return false;
      }
      return true;
    },
    isReCorrect(familyMembers) {
      let rAry = familyMembers.map((item) => item.cop_name);
      let repeat = rAry.filter(function(element, index, arr) {
        return arr.indexOf(element) !== index;
      });
      if (repeat && repeat.length > 0) {
        this.$toast.info({
          title: `${[...new Set(repeat)]} : 成員與主被保人重複，請確認。`
        });
        return false;
      }
      return true;
    },
    isFamilies(familyMembers) {
      return familyMembers
        .map((x) => x.cop_id)
        .filter((x) => x)
        .some((csidno) =>
          this.options.families.map((x) => x.csidno).includes(csidno)
        );
    },
    //主被保人sel()
    toOpenNameSel(csid) {
      let rAry = this.originalFamilyList
        .filter((x) => !x.cop_birthday)
        .map((item) => item.cop_id);
      return this.options.families.filter(
        (x) =>
          (x.csidno !== csid && x.birthday) ||
          (rAry && rAry.length > 0 && x.csidno.includes(rAry) && !x.birthday)
      );
    },
    //更新主被保人家戶列表
    getfamilyOwner(familyIndex) {
      let count = this.familyDatas.length - 1;
      this.familyOwner = this.familyDatas[familyIndex];
      if (!this.familyOwnerList.includes(this.familyOwner.plcno)) {
        this.familyOwnerList.push(this.familyOwner.plcno);
      }
      if (count === familyIndex) {
        this.isSave = true; //多筆家戶成員.最後一筆為true存檔
      }
    },
    //是否為家戶成員
    isIncludes(csidno) {
      const rAry = this.options.families.map((x) => x.csidno).includes(csidno);
      return rAry;
    },
    updateFamilyIndex() {
      this.familyIndex = this.familyIndex + 1;
      this.familyMembers = [];
      this.getfamilyOwner(this.familyIndex);
      this.getFamilyRelationOfInsurance();
    },
    toSelfPlcnoEditList(query) {
      this.$router.push({
        name: "policyInfo-edit-list",
        query
      });
    },
    toSelfPlcno() {
      localStorage.insurances = JSON.stringify(this.insurances);
      localStorage.familyDatas = JSON.stringify([]);
      this.$router.push({
        name: "self-input-policy-number",
        query: { selfPlcno: true }
      });
    },
    //民國轉西元 
    getChineseDateFormate(cop_birthday) {
      if (cop_birthday) {
        let str = String(cop_birthday);
        let y = Number(str.substr(0, str.length - 4)) + 1911;
        let m = str.slice(-4, -2);
        let d = str.slice(-2);
        return `${y}-${m}-${d}`;
      } else {
        return "";
      }
    }
  }
};
